<template>
    <div class="row justify-content-center report-elements" id="reporting_data">
        <div v-if="isBuilt" class="col">
            <template v-for="element in elementsData">
                <template v-if="element.element_abbreviation == 'topline_stats'">
                    <kpi-top :kpi-data="element" :isBuilt="isBuilt" :hasSkb="hasSkb"></kpi-top>
                </template>
                <template v-if="element.element_abbreviation == 'report_highlights'">
                    <report-highlights :highlights-data="element" :isBuilt="isBuilt" :isGuest="isGuest" :hasSkb="hasSkb"></report-highlights>
                </template>
                <template v-if="element.element_abbreviation == 'single_table_grouping'">
                    <template v-if="element.showAsTriple">
                        <triple-table :table-data="element" :isBuilt="isBuilt" :hasSkb="hasSkb"></triple-table>
                    </template>
                    <template v-else>
                        <single-table :table-data="element" :isBuilt="isBuilt" :hasSkb="hasSkb"></single-table>
                    </template>
                </template>
                <template v-if="element.element_abbreviation == 'single_table_grouping_blue'">
                    <single-table-blue :table-data="element" :isBuilt="isBuilt" :hasSkb="hasSkb"></single-table-blue>
                </template>
                <template v-if="element.element_abbreviation == 'double_table_grouping'">
                    <double-table :table-data="element" :isBuilt="isBuilt" :hasSkb="hasSkb"></double-table>
                </template>
                <template v-if="element.element_abbreviation == 'triple_table_grouping'">
                    <triple-table :table-data="element" :isBuilt="isBuilt" :hasSkb="hasSkb"></triple-table>
                </template>
                <template v-if="element.element_abbreviation == 'adwords_text_ads'">
                    <adwords-visuals :adwords-data="element" :isBuilt="isBuilt" :hasSkb="hasSkb"></adwords-visuals>
                </template>
                <template v-if="element.element_abbreviation == 'updates_insights'">
                    <updates-and-insights :updates-and-insights-data="element" :isBuilt="isBuilt" :hasSkb="hasSkb" :isGuest="isGuest"></updates-and-insights>
                </template>
                <template v-if="element.element_abbreviation == 'advert_visuals'">
                    <advertising-visuals :advertising-visuals-data="element" :isBuilt="isBuilt" :hasSkb="hasSkb"></advertising-visuals>
                </template>
                <template v-if="element.element_abbreviation == 'traffic_trends'">
                    <chart :chart-data="element" :isBuilt="isBuilt" :hasSkb="hasSkb" :isGuest="isGuest"></chart>
                </template>
                <template v-if="element.element_abbreviation == 'social_kpi'">
                    <kpi-social :kpi-data="element" :isBuilt="isBuilt" :hasSkb="hasSkb"></kpi-social>
                </template>
                <template v-if="element.element_abbreviation == 'social_campaign_details'">
                    <social-campaign-details :social-campaign-details-data="element" :isBuilt="isBuilt" :hasSkb="hasSkb"></social-campaign-details>
                </template>
                <template v-if="element.element_abbreviation == 'top_social_ad_creatives'">
                    <top-social-ad-creatives :top-social-ad-creatives-data="element" :isBuilt="isBuilt" :hasSkb="hasSkb" :isGuest="isGuest"></top-social-ad-creatives>
                </template>
                <template v-if="element.element_abbreviation == 'social_key_takeaways'">
                    <social-key-takeaways :takeaways-data="element" :isBuilt="isBuilt" :hasSkb="hasSkb" :isGuest="isGuest"></social-key-takeaways>
                </template>
                <template v-if="element.element_abbreviation == 'key_takeaways'">
                    <key-takeaways :takeaways-data="element" :isBuilt="isBuilt" :hasSkb="hasSkb" :isGuest="isGuest"></key-takeaways>
                </template>
                <template v-if="element.element_abbreviation == 'social_organic_performance_highlights'">
                    <social-organic-performance-highlights :soph-data="element" :isBuilt="isBuilt" :hasSkb="hasSkb"></social-organic-performance-highlights>
                </template>
                <template v-if="element.element_abbreviation == 'social_organic_instagram_grid'">
                    <social-organic-instagram-grid :soig-data="element" :isBuilt="isBuilt" :hasSkb="hasSkb"></social-organic-instagram-grid>
                </template>
                <template v-if="element.element_abbreviation == 'commentary'">
                    <text-box :commentary-data="element" :isBuilt="isBuilt" :hasSkb="hasSkb"></text-box>
                </template>
                <template v-if="element.element_abbreviation == 'heading'">
                    <heading :heading-data="element" :isBuilt="isBuilt" :hasSkb="hasSkb"></heading>
                </template>
                <template v-if="element.element_abbreviation == 'metric_glossary'">
                    <metric-glossary :metric-glossary-data="element" :isBuilt="isBuilt" :hasSkb="hasSkb"></metric-glossary>
                </template>
                <template v-if="element.element_abbreviation == 'page_break'">
                    <page-break></page-break>
                </template>
            </template>
            <div class="text-center export-icons margin-top50">
                <button id="generate_pdf" @click="generatePDF" type="button" class="hidden"></button>
                <img @click="exportPDF" :src="`${$store.state.app_url}images/export_icons/ex_pdf.svg`">

                <button id="generate_ppt" @click="generatePPT" type="button" class="hidden"></button>
                <img class="margin-left20" @click="exportPPT" :src="`${$store.state.app_url}images/export_icons/ex_ppt.svg`">

                <button id="generate_ppt_portrait" @click="generatePPTPortrait" type="button" class="hidden"></button>
                <img class="margin-left20" @click="exportPPTPortrait" :src="`${$store.state.app_url}images/export_icons/ex_ppt.svg`">

                <template v-if="!isGuest">
                    <img class="margin-left20 google-slides-icon" @click="exportGoogleSlide('')" :src="`${$store.state.app_url}images/export_icons/google_slides.png`">
                    <img class="margin-left20 google-slides-icon" @click="exportGoogleSlide('portrait')" :src="`${$store.state.app_url}images/export_icons/google_slides.png`">
                </template>
            </div>
            <!--<button v-if="showChatGPT_Button" class="btn btn-secondary chat-gpt" @click="chatPopup">chatGPT</button>-->
        </div>
        <div v-if="dataReady && showChatGPT_Button" class="modal fade" id="chat_gpt_modal" tabindex="-1" role="dialog" aria-hidden="true">
            <div class="modal-dialog modal-dialog-centered modal-xg" role="document">
                <div class="modal-content UpdatesAndInsights">
                    <div class="modal-header padding-x15 padding-y10">
                        <span>Date Period: <span class="ml-5 small">{{dateFrom}} TO {{dateTo}} VS {{dateCompareFrom}} TO {{dateCompareTo}}</span></span>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>

                    <div class="modal-body">
                        <div class="row">
                            <div class="col"><h6 class="text-uppercase">Set Questions:</h6></div>
                        </div>
                        <div class="row">
                            <div class="col d-flex flex-column gap-10">
                                <div class="row justify-content-between">
                                    <div class="col-10 h7">1. {{question1}}</div>
                                    <div class="col-2 text-left"><button :disabled="use_q1 && answear1" class="btn btn-secondary" @click="toggleUse(1)"><span v-if="!use_q1">USE</span><span v-if="use_q1">REMOVE</span></button></div>
                                </div>
                                <div class="row justify-content-between">
                                    <div class="col-10 h7">2. {{question2}}</div>
                                    <div class="col-2 text-left"><button :disabled="use_q2 && answear2" class="btn btn-secondary" @click="toggleUse(2)"><span v-if="!use_q2">USE</span><span v-if="use_q2">REMOVE</span></button></div>
                                </div>
                                <div class="row justify-content-between">
                                    <div class="col-10 h7">3. {{question3}}</div>
                                    <div class="col-2 text-left"><button :disabled="use_q3 && answear3" class="btn btn-secondary" @click="toggleUse(3)"><span v-if="!use_q3">USE</span><span v-if="use_q3">REMOVE</span></button></div>
                                </div>
                                <div class="row justify-content-between">
                                    <div class="col-10 h7">4. {{question4}}</div>
                                    <div class="col-2 text-left"><button :disabled="use_q4 && answear4" class="btn btn-secondary"  @click="toggleUse(4)"><span v-if="!use_q4">USE</span><span v-if="use_q4">REMOVE</span></button></div>
                                </div>
                            </div>
                        </div>
                        <div class="px-4 mt-4">
                            <div class="row bordered">
                                <div class="col d-flex flex-column gap-10 scrolling">
                                    <div v-if="chatReloading" class="spinner element-spinner chatGPT d-flex flex-column justify-content-center align-items-center">
                                        <span class="spinner-border spinner-border-sm margin-right5" role="status" aria-hidden="true"></span>
                                    </div>
                                    <div v-if="chatReloading" class="spinner-aux">

                                    </div>
                                    <div v-if="use_q1" class="row justify-content-between">
                                        <div class="col-12 h7"><span>Q: {{question1}}</span></div>
                                        <div v-if="answear1" class="col-12 h7"><span v-html="'Database: ' + answear1"></span></div>
                                    </div>
                                    <div v-if="use_q2" class="row justify-content-between">
                                        <div class="col-12 h7"><span>Q: {{question2}}</span></div>
                                        <div v-if="answear2" class="col-12 h7"><span v-html="'Database: ' + answear2"></span></div>
                                        <div v-if="answear2 && top20_2" class="col-12 h7"><span v-html="top20_2"></span></div>
                                    </div>
                                    <div v-if="use_q3" class="row justify-content-between">
                                        <div class="col-12 h7"><span>Q: {{question3}}</span></div>
                                        <div v-if="answear3 && data3" class="col-12 h7"><span>Data: {{data3}}</span></div>
                                        <div v-if="answear3" class="col-12 h7"><span v-if="data3" v-html="'chatGPT: ' + answear3"></span><span v-else v-html="'Database: ' + answear3"></span></div>
                                    </div>
                                    <div v-if="use_q4" class="row justify-content-between">
                                        <div class="col-12 h7"><span>Q: {{question4}}</span></div>
                                        <div v-if="answear4" class="col-12 h7"><span v-html="'Database: ' + answear4"></span></div>
                                        <div v-if="answear4 && top20_4" class="col-12 h7"><span v-html="top20_4"></span></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="padding-y10" :class="enableAddData ? 'row px-5' : 'modal-footer'">
                        <div v-if="enableAddData" class="col-4">
                            <v-select :options="filteredElementsData" label="name" v-model="selectedElement"></v-select>
                        </div>
                        <div v-if="enableAddData" class="col-4">
                            <button type="button" class="btn btn-secondary">ADD DATA</button>
                        </div>
                        <div class="text-right" :class="enableAddData ? 'col-4' : 'col-12'">
                            <button :disabled="responses || chatReloading" type="button" class="btn btn-secondary" @click="autoPopulateData">ASK</button>
                            <button :disabled="!chat_has_data" type="button" class="btn btn-secondary" @click="resetChatGPTPopUp">CLEAR</button>
                        </div>

                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        props: ['isBuilt', 'hasSkb', 'elementsData', 'reportOrArchive', 'isGuest'],

        created() {
            event_bus.$on('current_dwm', () => {
                this.current_dwm = this.$store.state.current_dwm;
            });
            event_bus.$on('show_chatGPT', (params) => {
                this.edit_num++;
                if(!this.showChatGPT_Button){
                    this.chat_params = params;
                    this.dateFrom           = vm.$dayjs(this.chat_params.date_from).format("MM-DD-YYYY");
                    this.dateTo             = vm.$dayjs(this.chat_params.date_to).format("MM-DD-YYYY");
                    this.dateCompareFrom    = vm.$dayjs(this.chat_params.date_compare_from).format("MM-DD-YYYY");
                    this.dateCompareTo      = vm.$dayjs(this.chat_params.date_compare_to).format("MM-DD-YYYY");
                    this.showChatGPT_Button = true;
                }
            });
            event_bus.$on('hide_chatGPT', () => {
                this.edit_num--;
                if(this.edit_num < 0){
                    this.edit_num = 0;
                }
                if(this.edit_num == 0){
                    this.showChatGPT_Button = false;
                    //this.resetChatGPTPopUp();
                }
            });
            this.question1 = "Based on the trends in the last 8 full weeks, do we expect total users and total conversions in the subsequent 4 weeks to increase, decrease, or remain steady and why?";
            this.question2 = "Which keywords would make sense to remove from our Paid Search campaigns based on the cost per click and the cost per acquisition and why?";
            this.question3 = "Which Display audience type has received the most clicks and conversions over the past 90 days? Which audience type has received the least amount of clicks and conversions over the past 90 days?";
            this.question4 = "Which campaigns would make sense to turn off from our Paid Search campaigns based on the cost per click and the cost per acquisition and why?";
        },

        data() {
            return {
                current_dwm: this.$store.state.current_dwm,

                pdf_exporting:   false,
                ppt1_exporting:  false,
                ppt2_exporting:  false,
                slide_exporting: false,
                //the following data are used by the chatGPT popup

                dateFrom:null,
                dateTo:null,
                dateCompareFrom:null,
                dateCompareTo:null,
                question1:null,
                question2:null,
                question3:null,
                question4:null,
                answear1:null,
                answear2:null,
                answear3:null,
                data3:null,
                answear4:null,
                use_q1:false,
                use_q2:false,
                use_q3:false,
                use_q4:false,
                selectedElement:null,
                enableAddData:false,
                top20_1:null,
                top20_2:null,
                top20_4:null,
                chatReloading:false,
                showChatGPT_Button:false,
                chat_params:null,
                dataReady:null,
                edit_num:0,
                chat_has_data:false
            }
        },
        mounted(){
            $('#chat_gpt_modal').on('hidden.bs.modal', () => {
                this.resetChatGPTPopUp();
            });
        },
        computed: {
            filteredElementsData() {
                const excludeList = [
                    "commentary",
                    "empty",
                    "report_highlights",
                    "updates_insights",
                    "heading",
                    "page_break",
                    "metric_glossary",
                    "key_takeaways"
                ];
                return this.elementsData.filter(item => {
                    return !excludeList.includes(item.element_abbreviation);
                });
            },
            responses(){
                return (!this.use_q1 || (this.use_q1 && this.answear1)) &&
                    (!this.use_q2 || (this.use_q2 && this.answear2)) &&
                    (!this.use_q3 || (this.use_q3 && this.answear3)) &&
                    (!this.use_q4 || (this.use_q4 && this.answear4));
            }
        },
        methods:{
            chatPopup() {
                $('#chat_gpt_modal').modal('show');
            },
            autoPopulateData() {
                const report_element_id = this.chat_params.report_element_id;
                this.chatReloading = true;
                this.chat_params['use_q1'] = this.use_q1;
                this.chat_params['use_q2'] = this.use_q2;
                this.chat_params['use_q3'] = this.use_q3;
                this.chat_params['use_q4'] = this.use_q4;

                const params = encodeURIComponent(JSON.stringify(this.chat_params));

                axios.get(`/api/reporting/updates_insights_autopopulate/${this.$route.params.report_id}/?params=${params}`).then((updatesAndInsightsData) => {
                    if (updatesAndInsightsData.data) {
                        if(this.use_q1 && !this.answear1){
                            this.answear1 = updatesAndInsightsData.data.update1.response;
                            this.top20_1 = updatesAndInsightsData.data.update1.top20;
                        }
                        if(this.use_q2 && !this.answear2){
                            this.answear2 = updatesAndInsightsData.data.update2.response;
                            this.top20_2 = updatesAndInsightsData.data.update2.top20;
                        }
                        if(this.use_q3 && !this.answear3){
                            this.answear3 = updatesAndInsightsData.data.update3.response;
                            this.data3 = updatesAndInsightsData.data.update3.out;
                        }
                        if(this.use_q4 && !this.answear4){
                            this.answear4 = updatesAndInsightsData.data.update4.response;
                            this.top20_4 = updatesAndInsightsData.data.update4.top20;
                        }
                    }
                    this.chatReloading = false;
                    this.chat_has_data = true;
                });
            },
            toggleUse(question){
                switch(question){
                    case 1:
                        this.use_q1 = !this.use_q1;
                        break;
                    case 2:
                        this.use_q2 = !this.use_q2;
                        break;
                    case 3:
                        this.use_q3 = !this.use_q3;
                        break;
                    case 4:
                        this.use_q4 = !this.use_q4;
                        break;
                }
            },
            resetChatGPTPopUp(){
                //this.chat_params = null;
                this.answear1 = null;
                this.answear2 = null;
                this.answear3 = null;
                this.data3 = null;
                this.answear4 = null;
                this.use_q1 = false;
                this.use_q2 = false;
                this.use_q3 = false;
                this.use_q4 = false;
                this.top20_1 = null;
                this.top20_2 = null;
                this.top20_4 = null;
                this.chat_has_data = false;
                this.selectedElement = this.filteredElementsData[0];
            },
            openFroalaEditor(){
                $('#reporting_data').find('.froala').off('froalaEditor.initialized').froalaEditor({
                    key: 'AA12B9A4A4xC2D2F2B2A29A3C3A8B1D2sg1Ti1LXd2URVJh1DWXG==',
                    height: 200,
                    charCounterCount: false,
                    requestWithCORS: false,
                    htmlExecuteScripts: false,
                    htmlUntouched: true,
                    htmlAllowedTags: ['a', 'abbr', 'address', 'area', 'article', 'aside', 'b', 'base', 'blockquote', 'br', 'button', 'caption', 'cite', 'col', 'colgroup', 'datalist', 'dd', 'del', 'details', 'dfn', 'div', 'dl', 'dt', 'em', 'fieldset', 'figcaption', 'figure', 'footer', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'header', 'hgroup', 'hr', 'i', 'img', 'ins', 'label', 'legend', 'li', 'link', 'main', 'map', 'mark', 'menu', 'menuitem', 'nav', 'ol', 'optgroup', 'p', 'param', 'pre', 'progress', 'queue', 'rp', 'rt', 's', 'section', 'small', 'span', 'strike', 'strong', 'sub', 'summary', 'sup', 'table', 'tbody', 'td', 'tfoot', 'th', 'thead', 'title', 'tr', 'u', 'ul'],
                    htmlRemoveTags: ['script', 'form', 'style', 'iframe', 'input', 'select', 'option', 'video', 'audio', 'canvas', 'code', 'object', 'keygen'],
                    toolbarButtons: ['bold', 'italic', 'underline', 'strikeThrough', 'subscript', 'superscript', 'fontFamily', 'fontSize', 'color', 'formatOL', 'formatUL', 'insertLink', 'insertTable', 'specialCharacters', 'insertHR', 'selectAll', 'clearFormatting', 'undo', 'redo'],
                    fontFamily: {
                        "Arial, Helvetica, sans-serif": 'Arial',
                        "Georgia, serif": 'Georgia',
                        "Impact, Charcoal, sans-serif": 'Impact',
                        "Tahoma, Geneva, sans-serif": 'Tahoma',
                        "Times New Roman, Times, serif": 'Times New Roman',
                        "Verdana, Geneva, sans-serif": 'Verdana',
                        "BentonSans Regular": 'BentonSans Regular',
                    }
                });
            },

            exportPDF() {
                this.showLoader();
                this.pdf_exporting = true;
                const params = JSON.stringify({
                    dwm: this.$store.state.current_dwm,
                    dates: this.$store.state.current_dates
                });

                axios.get(`/api/reporting/${this.$route.params.report_id}/export-pdf?params=${params}&is_guest=${this.isGuest}`).then(response => {
                    this.hideLoader();

                    const queryString = $.param({
                        dwm:               this.$store.state.current_dwm,
                        date_from:         this.$store.state.current_dates.date_from,
                        date_to:           this.$store.state.current_dates.date_to,
                        date_compare_from: this.$store.state.current_dates.date_compare_from,
                        date_compare_to:   this.$store.state.current_dates.date_compare_to
                    });
                    this.pdf_exporting = false;
                    window.location.href = this.$store.state.app_url + `api/reporting/${this.$route.params.report_id}/download-exported-pdf?${queryString}`;
                });
            },

            generatePDF() {
                const self = this;
                this.pdf_exporting = true;
                this.showLoader();

                $('#reporting_view').find('button, .edit-annotations').hide();

                const dateFrom        = vm.$dayjs(this.$store.state.current_dates.date_from).format("MMM DD YYYY");
                const dateTo          = vm.$dayjs(this.$store.state.current_dates.date_to).format("MMM DD YYYY");
                const dateCompareFrom = vm.$dayjs(this.$store.state.current_dates.date_compare_from).format("MMM DD YYYY");
                const dateCompareTo   = vm.$dayjs(this.$store.state.current_dates.date_compare_to).format("MMM DD YYYY");

                setTimeout(() => {
                    self.processRemoteIframesAndImages().then(() => {
                        const ratios   = [];
                        const promises = [];
                        const headings = [];

                        $('#reporting_view').find('.top-image-wrap').add($('#reporting_data').find('> .col > div')).not('.export-icons').each(function(i, value) {
                            ratios.push($(this).height() / $(this).width());
                            promises.push(html2canvas(this, { logging: false, scale: 1.5 }));

                            if ($(this).hasClass('heading')) {
                                headings.push(i);
                            }
                        });

                        Promise.all(promises).then(canvasElements => {
                            const pdf             = new jsPDF('P', 'px');
                            const width           = pdf.internal.pageSize.getWidth() - 22;
                            let nextElementOffset = 22;
                            let firstElInPage     = false;
                            let page              = 1;

                            pdf.setFont('helvetica', 'normal');
                            pdf.setTextColor('#333333');
                            pdf.setFontSize(9);
                            pdf.text('' + page++, pdf.internal.pageSize.getWidth() / 2, pdf.internal.pageSize.getHeight() - 10);

                            _.each(canvasElements, (canvas, index) => {
                                const height = ratios[index] * width;

                                if (((nextElementOffset + height + 10) > pdf.internal.pageSize.getHeight()) || headings.indexOf(index) > -1) {
                                    pdf.addPage();
                                    pdf.setFont('helvetica', 'normal');
                                    pdf.setTextColor('#333333');
                                    pdf.setFontSize(9);
                                    pdf.text('' + page++, pdf.internal.pageSize.getWidth() / 2, pdf.internal.pageSize.getHeight() - 10);

                                    firstElInPage = true;
                                    nextElementOffset = 22;
                                }

                                pdf.addImage(canvas.toDataURL(), 'PNG', 11, nextElementOffset, width, height, '', 'FAST');

                                if (firstElInPage) {
                                    if (this.reportOrArchive.export_show_header_text) {
                                        pdf.setFont('helvetica', 'normal');
                                        pdf.setTextColor('#333333');
                                        pdf.setFontSize(9);
                                        pdf.text(this.elementsData[0].client_name, pdf.internal.pageSize.getWidth() - 22, 16, {align: 'right'});
                                        pdf.text(`${dateFrom} - ${dateTo}`, pdf.internal.pageSize.getWidth() - 22, 26, {align: 'right'});
                                    }

                                    firstElInPage = false;
                                }

                                nextElementOffset += height + 10;
                            });

                            const blob     = pdf.output('blob');
                            const formData = new FormData();

                            formData.append('file', blob);
                            formData.append('report_id', this.$route.params.report_id);

                            this.ajaxSubmit({'Content-Type': 'multipart/form-data'}, 'POST', '/api/reporting/save-exported-pdf', formData).then(() => {
                                self.hideLoader();
                                self.pdf_exporting = false;
                            }).catch(() => {
                                self.hideLoader();
                                self.pdf_exporting = false;
                            });
                        });
                    });
                }, 500);
            },

            exportPPT() {
                this.showLoader();
                this.ppt1_exporting = true;
                const params = JSON.stringify({
                    dwm: this.$store.state.current_dwm,
                    dates: this.$store.state.current_dates
                });

                axios.get(`/api/reporting/${this.$route.params.report_id}/export-ppt?params=${params}&is_guest=${this.isGuest}`).then(response => {
                    this.hideLoader();

                    const queryString = $.param({
                        dwm:               this.$store.state.current_dwm,
                        date_from:         this.$store.state.current_dates.date_from,
                        date_to:           this.$store.state.current_dates.date_to,
                        date_compare_from: this.$store.state.current_dates.date_compare_from,
                        date_compare_to:   this.$store.state.current_dates.date_compare_to
                    });
                    this.ppt1_exporting = false;
                    window.location.href = this.$store.state.app_url + `api/reporting/${this.$route.params.report_id}/download-exported-ppt?${queryString}`;
                });
            },

            generatePPT() {
                const self = this;
                this.ppt1_exporting = true;
                this.showLoader();
                //axios.post(`/api/reporting/generate-pdf`, {step:'a'}).then(response => {});
                $('#reporting_view').find('button, .edit-annotations').hide();

                const emu2Inch        = emu => emu / 914400;
                const px2Inch         = px  => px / 96;
                const promises        = [];
                const dateFrom        = vm.$dayjs(this.$store.state.current_dates.date_from).format("MMM DD YYYY");
                const dateTo          = vm.$dayjs(this.$store.state.current_dates.date_to).format("MMM DD YYYY");
                const dateCompareFrom = vm.$dayjs(this.$store.state.current_dates.date_compare_from).format("MMM DD YYYY");
                const dateCompareTo   = vm.$dayjs(this.$store.state.current_dates.date_compare_to).format("MMM DD YYYY");

                setTimeout(() => {
                    self.processRemoteIframesAndImages().then(() => {
                        const ratios   = [];
                        const promises = [];

                        $('#reporting_view').find('.top-image-wrap').add($('#reporting_data').find('> .col > div')).not('.export-icons').each(function() {
                            ratios.push($(this).height() / $(this).width());
                            promises.push(html2canvas(this, { logging: false, scale: 1.5 }));
                        });

                        Promise.all(promises).then(canvasElements => {
                            const pptx = new PptxGenJS;

                            _.each(canvasElements, (canvas, index) => {
                                const slide = pptx.addNewSlide();
                                const ratio = px2Inch(canvas.width) / px2Inch(canvas.height);
                                let width   = emu2Inch(pptx.presLayout.width);
                                let height  = emu2Inch(pptx.presLayout.height);

                                if (px2Inch(canvas.width) > width || px2Inch(canvas.height) > height) {
                                    if ((px2Inch(canvas.width) / width) > px2Inch(canvas.height) / height) {
                                        height = width / ratio;
                                    } else {
                                        width = height * ratio;
                                    }
                                }

                                slide.addImage({
                                    data: canvas.toDataURL(),
                                    x: (emu2Inch(pptx.presLayout.width) - (width / 1.1)) / 2,
                                    y: (emu2Inch(pptx.presLayout.height) - (height / 1.1)) / 2,
                                    w: width / 1.1,
                                    h: height / 1.1
                                });

                                slide.addText('' + (index + 1), {
                                    fontSize: 9,
                                    x:        1.13,
                                    y:        5.1,
                                    color:    '333333',
                                    align:    'center',
                                    valign:   'bottom',
                                    fontFace: 'Helvetica'
                                });
                            });

                            pptx.write('blob').then(blob => {
                                const formData = new FormData();

                                formData.append('file', blob);
                                formData.append('report_id', self.$route.params.report_id);

                                self.ajaxSubmit({'Content-Type': 'multipart/form-data'}, 'POST', '/api/reporting/save-exported-ppt', formData).then(() => {
                                    self.hideLoader();
                                    self.ppt1_exporting = false;
                                }).catch(() => {
                                    self.hideLoader();
                                    self.ppt1_exporting = false;
                                });
                            }).catch(error => {
                                console.error(error);
                                self.ppt1_exporting = false;
                            });
                        });
                    });
                }, 500);
            },

            exportPPTPortrait() {
                this.showLoader();
                this.ppt2_exporting = true;
                const params = JSON.stringify({
                    dwm: this.$store.state.current_dwm,
                    dates: this.$store.state.current_dates,
                });

                axios.get(`/api/reporting/${this.$route.params.report_id}/export-ppt?params=${params}&orientation=portrait&is_guest=${this.isGuest}`).then(response => {
                    this.hideLoader();

                    const queryString = $.param({
                        dwm:               this.$store.state.current_dwm,
                        date_from:         this.$store.state.current_dates.date_from,
                        date_to:           this.$store.state.current_dates.date_to,
                        date_compare_from: this.$store.state.current_dates.date_compare_from,
                        date_compare_to:   this.$store.state.current_dates.date_compare_to
                    });
                    this.ppt2_exporting = false;
                    window.location.href = this.$store.state.app_url + `api/reporting/${this.$route.params.report_id}/download-exported-ppt?${queryString}`;
                });
            },

            generatePPTPortrait() {
                const self = this;
                this.ppt2_exporting = true;
                this.showLoader();

                $('#reporting_view').find('button, .edit-annotations').hide();

                const emu2Inch        = emu => emu / 914400;
                const px2Inch         = px  => px / 96;
                const pt2Inch         = pt  => pt * 0.0138;
                const promises        = [];
                const dateFrom        = vm.$dayjs(this.$store.state.current_dates.date_from).format("MMM DD YYYY");
                const dateTo          = vm.$dayjs(this.$store.state.current_dates.date_to).format("MMM DD YYYY");
                const dateCompareFrom = vm.$dayjs(this.$store.state.current_dates.date_compare_from).format("MMM DD YYYY");
                const dateCompareTo   = vm.$dayjs(this.$store.state.current_dates.date_compare_to).format("MMM DD YYYY");

                setTimeout(() => {
                    self.processRemoteIframesAndImages().then(() => {
                        const ratios   = [];
                        const promises = [];
                        const headings = [];

                        $('#reporting_view').find('.top-image-wrap').add($('#reporting_data').find('> .col > div')).not('.export-icons').each(function(i, value) {
                            ratios.push($(this).height() / $(this).width());
                            promises.push(html2canvas(this, { logging: false, scale: 1.5 }));

                            if ($(this).hasClass('heading')) {
                                headings.push(i);
                            }
                        });

                        Promise.all(promises).then(canvasElements => {
                            const pptx = new PptxGenJS;

                            pptx.defineLayout({name: 'LAYOUT_16x10_PORTRAIT', width: 6.25, height: 10});
                            pptx.layout = 'LAYOUT_16x10_PORTRAIT';

                            var slide             = pptx.addNewSlide();
                            const width           = emu2Inch(pptx.presLayout.width);
                            let nextElementOffset = pt2Inch(30);
                            let firstElInPage     = false;
                            let page              = 1;

                            slide.addText('' + (page++), {
                                fontSize: 9,
                                x:        1.13,
                                y:        9.6,
                                color:    '333333',
                                align:    'center',
                                valign:   'bottom',
                                fontFace: 'Helvetica'
                            });

                            _.each(canvasElements, (canvas, index) => {
                                const height = ratios[index] * width;

                                if (((nextElementOffset + height + pt2Inch(10)) > emu2Inch(pptx.presLayout.height)) || headings.indexOf(index) > -1) {
                                    slide = pptx.addNewSlide();
                                    slide.addText('' + (page++), {
                                        fontSize: 9,
                                        x:        1.13,
                                        y:        9.6,
                                        color:    '333333',
                                        align:    'center',
                                        valign:   'bottom',
                                        fontFace: 'Helvetica'
                                    });

                                    firstElInPage = true;
                                    nextElementOffset = pt2Inch(30);
                                }

                                slide.addImage({
                                    data: canvas.toDataURL(),
                                    x: (emu2Inch(pptx.presLayout.width) - (width / 1.1)) / 2,
                                    y: nextElementOffset,
                                    w: width / 1.1,
                                    h: height / 1.1
                                });

                                if (firstElInPage) {
                                    slide.addText(`${this.elementsData[0].client_name}\n${dateFrom} - ${dateTo}`, {
                                        fontSize: 9,
                                        x:        1.13,
                                        y:        0.02,
                                        color:    '333333',
                                        align:    'right',
                                        valign:   'top',
                                        fontFace: 'Helvetica'
                                    });

                                    firstElInPage = false;
                                }

                                nextElementOffset += height + pt2Inch(10);
                            });

                            pptx.write('blob').then(blob => {
                                const formData = new FormData();

                                formData.append('file', blob);
                                formData.append('report_id', self.$route.params.report_id);

                                self.ajaxSubmit({'Content-Type': 'multipart/form-data'}, 'POST', '/api/reporting/save-exported-ppt', formData).then(() => {
                                    self.hideLoader();
                                    self.ppt2_exporting = false;
                                }).catch(() => {
                                    self.hideLoader();
                                    self.ppt2_exporting = false;
                                });
                            }).catch(error => {
                                console.error(error);
                                self.ppt2_exporting = false;
                            });
                        });
                    });
                }, 500);
            },

            exportGoogleSlide(orientation) {
                this.showLoader();
                this.slide_exporting = true;

                const params = JSON.stringify({
                    dwm:   this.$store.state.current_dwm,
                    dates: this.$store.state.current_dates,
                });

                const exportWindow = window.open(this.$store.state.app_url + 'loading/' + btoa('Exporting to Google Slides, please be patient as this may take 1-2 minutes ...'));

                axios.get(`/api/reporting/${this.$route.params.report_id}/export-ppt?params=${params}&upload_to_drive=true&orientation=${orientation}&is_guest=${this.isGuest}`).then(response => {
                    this.hideLoader();
                    this.slide_exporting = false;

                    exportWindow.location.href = response.data.url;
                });
            },

            processRemoteIframesAndImages() {
                return new Promise((resolve, reject) => {
                    if ($('#reporting_view').find('iframe, img[width], img[remote]').length > 0) {
                        let data = [];

                        $('#reporting_view').find('iframe, img[width], img[remote]').each(function() {
                            if (this.nodeName === 'IFRAME') {
                                data.push({
                                    url:    $(this).attr('src'),
                                    width:  $(this).attr('width'),
                                    height: $(this).attr('height')
                                });
                            } else {
                                data.push({
                                    url:    $(this).attr('src'),
                                    width:  this.naturalWidth,
                                    height: this.naturalHeight
                                });
                            }
                        });

                        axios.post('/api/browsershot', { data: JSON.stringify(data) }).then(response => {
                            $('#reporting_view').find('iframe, img[width], img[remote]').each(function(index, element) {
                                if (this.nodeName === 'IFRAME') {
                                    let img    = new Image;
                                    img.src    = response.data[index];
                                    img.width  = data[index].width;
                                    img.height = data[index].height;

                                    $(element).before(img);
                                    $(element).remove();
                                } else {
                                    $(element).attr('src', response.data[index]);
                                }
                            });

                            resolve();
                        });
                    } else {
                        resolve();
                    }
                });
            },
            createLink(){

            }
        },
        watch: {
            elementsData(newVal, oldVal){
                if(newVal){
                    this.selectedElement = this.filteredElementsData[0];
                    this.dataReady = true;
                }
            },
            pdf_exporting() {
                if (this.pdf_exporting) {
                    $('fieldset').addClass('pdf_exporting').parent().addClass('pdf_exporting');
                    $('.v-scroll-overlay').addClass('pdf_exporting');
                    $('.h-scroll-overlay').addClass('pdf_exporting');
                    $('.bubble-title.empty').addClass('pdf_exporting');
                    $('.pencil-wrap.empty').addClass('pdf_exporting');
                } else {
                    $('fieldset').removeClass('pdf_exporting').parent().removeClass('pdf_exporting');
                    $('.v-scroll-overlay').removeClass('pdf_exporting');
                    $('.h-scroll-overlay').removeClass('pdf_exporting');
                    $('.bubble-title.empty').removeClass('pdf_exporting');
                    $('.pencil-wrap.empty').removeClass('pdf_exporting');
                }
            },
            ppt1_exporting() {
                if (this.ppt1_exporting) {
                    $('fieldset').addClass('ppt1_exporting').parent().addClass('ppt1_exporting');
                    $('.v-scroll-overlay').addClass('ppt1_exporting');
                    $('.h-scroll-overlay').addClass('ppt1_exporting');
                    $('.bubble-title.empty').addClass('ppt1_exporting');
                    $('.pencil-wrap.empty').addClass('ppt1_exporting');
                } else {
                    $('fieldset').removeClass('ppt1_exporting').parent().removeClass('ppt1_exporting');
                    $('.v-scroll-overlay').removeClass('ppt1_exporting');
                    $('.h-scroll-overlay').removeClass('ppt1_exporting');
                    $('.bubble-title.empty').removeClass('ppt1_exporting');
                    $('.pencil-wrap.empty').removeClass('ppt1_exporting');
                }
            },
            ppt2_exporting() {
                if (this.ppt2_exporting) {
                    $('fieldset').addClass('ppt2_exporting').parent().addClass('ppt2_exporting');
                    $('.v-scroll-overlay').addClass('ppt2_exporting');
                    $('.h-scroll-overlay').addClass('ppt2_exporting');
                    $('.bubble-title.empty').addClass('ppt2_exporting');
                    $('.pencil-wrap.empty').addClass('ppt2_exporting');
                } else {
                    $('fieldset').removeClass('ppt2_exporting').parent().removeClass('ppt2_exporting');
                    $('.v-scroll-overlay').removeClass('ppt2_exporting');
                    $('.h-scroll-overlay').removeClass('ppt2_exporting');
                    $('.bubble-title.empty').removeClass('ppt2_exporting');
                    $('.pencil-wrap.empty').removeClass('ppt2_exporting');
                }
            },

            slide_exporting() {
                if (this.slide_exporting) {
                    $('fieldset').addClass('slide_exporting').parent().addClass('slide_exporting');
                    $('.v-scroll-overlay').addClass('slide_exporting');
                    $('.h-scroll-overlay').addClass('slide_exporting');
                    $('.bubble-title.empty').addClass('slide_exporting');
                    $('.pencil-wrap.empty').addClass('slide_exporting');
                } else {
                    $('fieldset').removeClass('slide_exporting').parent().removeClass('slide_exporting');
                    $('.v-scroll-overlay').removeClass('slide_exporting');
                    $('.h-scroll-overlay').removeClass('slide_exporting');
                    $('.bubble-title.empty').removeClass('slide_exporting');
                    $('.pencil-wrap.empty').removeClass('slide_exporting');
                }
            }
        },
    }
</script>

<style lang="scss">
    @import '~@/_variables.scss';
    #reporting_data {
        > .col {
            > div {
                padding: 0 3rem;
            }
        }

        span.h-line{
            display:inline-block;
            border-top:0.3rem solid;
            border-bottom:0.3rem solid;
            border-radius:0.6rem;
            width:100%;
            &.page-break{
                color:transparent !important;
            }
        }
        p{
            &.highlights{
                color:#636466;
            }
        }
        .export-icons img {
            width: 5rem;
            cursor: pointer;

            &.google-slides-icon {
                width: 3.5rem;
            }
        }
        button.copy-link{
            padding:0.5rem 0;
            margin-top:-0.3rem;
        }

        button.chat-gpt {
            position: fixed;
            right: -30px;
            top: 50%;
            transform: rotate(-90deg) translateY(-50%); /* Rotate the button and shift it up by half its height */
            transform-origin: center;
            z-index: 1000;
        }
        div.row.bordered{
            border:solid 1px;
            border-radius: 4px;
            min-height: 50px;
        }
        .h7{
            font-size:14px;
        }
        .gap-10{
            gap:10px;
        }
        div.scrolling{
            max-height: 300px;
            overflow:auto;
        }
        .spinner.element-spinner.chatGPT{
            width:96% !important;
            height:100% !important;
            opacity:0.8 !important;
            top:0 !important;
        }
        .spinner-aux{
            position:absolute;
            width:96% !important;
            height:2000% !important;
            opacity:0.8 !important;
            background-color:white;
            top:100% !important;
            z-index:9999;
        }
        div.modal-xg{
            max-width:1000px !important;
        }
    }
</style>
